import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'app-node-link-viewer',
    templateUrl: './node-link-viewer.component.html',
    styleUrls: ['./node-link-viewer.component.scss']
})
export class NodeLinkViewerComponent implements OnInit {
    @Output() selectnode: EventEmitter<number> = new EventEmitter<number>();
    @Input() model: app.models.WorkflowNodeAnchorModel;
    constructor() { }

    ngOnInit() {
    }

    gotoNode(code: number) {
        this.selectnode.emit(code);
    }

}



// WEBPACK FOOTER //
// ./src/app/workflows/content-renderer/node-link-viewer/node-link-viewer.component.ts